import { render, staticRenderFns } from "./EmptyImageCol.vue?vue&type=template&id=37613696&scoped=true"
import script from "./EmptyImageCol.vue?vue&type=script&lang=js"
export * from "./EmptyImageCol.vue?vue&type=script&lang=js"
import style0 from "./EmptyImageCol.vue?vue&type=style&index=0&id=37613696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37613696",
  null
  
)

export default component.exports